import { render } from "./PWAInstall.vue?vue&type=template&id=0929e826&scoped=true"
import script from "./PWAInstall.vue?vue&type=script&lang=js"
export * from "./PWAInstall.vue?vue&type=script&lang=js"

import "./PWAInstall.vue?vue&type=style&index=0&id=0929e826&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0929e826"]])

export default __exports__